<!-- about information-->
<div #impressumId class="component-container">

  <!-- language de -->
  <ng-container *ngIf="languageCode==='de'">
    <h1>Kontakt / Impressum</h1>

    <p>
      Gerhard Rock<br>
      8054 Seiersberg-Pirka<br>
      Austria
    </p>
    <p>
      E-Mail an: trip4youmaps&#64;outlook.com
    </p>
  </ng-container>

  <!-- language en -->
  <ng-container *ngIf="languageCode!=='de'">
    <h1>Contact / Impressum</h1>
    <p>
      Gerhard Rock<br>
      8054 Seiersberg-Pirka<br>
      Austria
    </p>
    <p>
      Email to: trip4youmaps&#64;outlook.com
    </p>

  </ng-container>

</div>